import { Button } from '@/components/ui/button'
import {
    Sheet,
    SheetContent,
    SheetHeader,
    SheetTitle,
    SheetTrigger,
} from '@/components/ui/sheet'
import type { NavLink } from '@/data/nav-links'
import { Menu } from 'lucide-react'

type HeaderProps = {
    navLinks: Array<NavLink>
    mobileMenuOpen: boolean
    onMobileMenuChange: (open: boolean) => void
    onNavClick: (id: string) => void
    onLogoClick: () => void
}

export const Header = ({
    navLinks,
    mobileMenuOpen,
    onMobileMenuChange,
    onNavClick,
    onLogoClick,
}: HeaderProps) => {
    return (
        <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
            <div className="container mx-auto flex h-16 items-center justify-between px-4 sm:px-6 lg:px-8">
                {/* Logo */}
                <a
                    href="#"
                    onClick={(e) => {
                        e.preventDefault()
                        onLogoClick()
                    }}
                    className="text-xl font-semibold tracking-tight hover:text-primary transition-colors"
                >
                    Mythkin Realms
                </a>

                {/* Desktop Navigation Links - Centered */}
                <nav className="hidden lg:flex items-center gap-6">
                    {navLinks.map((link) => (
                        <a
                            key={link.id}
                            href={`#${link.id}`}
                            onClick={(e) => {
                                e.preventDefault()
                                onNavClick(link.id)
                            }}
                            className="text-sm font-medium text-muted-foreground transition-colors hover:text-foreground"
                        >
                            {link.label}
                        </a>
                    ))}
                </nav>

                {/* Right Side: Mobile Menu */}
                <div className="flex items-center gap-3">
                    <Sheet open={mobileMenuOpen} onOpenChange={onMobileMenuChange}>
                        <SheetTrigger asChild className="lg:hidden">
                            <Button variant="ghost" size="icon">
                                <Menu className="h-5 w-5" />
                                <span className="sr-only">Toggle menu</span>
                            </Button>
                        </SheetTrigger>
                        <SheetContent side="right" className="w-[300px] sm:w-[400px]">
                            <SheetHeader>
                                <SheetTitle>Navigation</SheetTitle>
                            </SheetHeader>
                            <nav className="flex flex-col gap-2 mt-6 px-1">
                                {navLinks.map((link) => (
                                    <Button
                                        key={link.id}
                                        variant="ghost"
                                        className="w-full justify-start text-base font-medium"
                                        onClick={() => onNavClick(link.id)}
                                    >
                                        {link.label}
                                    </Button>
                                ))}
                            </nav>
                        </SheetContent>
                    </Sheet>
                </div>
            </div>
        </header>
    )
}

